import { ITALogo } from "assets";
import { IKnowledgeSection } from "./types";

const corperateaffair: IKnowledgeSection = {
  key: "corperateaffair",
  title: "Corporate Affairs",
  // icon: ITALogo,
  color: "#eb2543",
  // TODO: these are placeholders copied from Income Tax — swap in the real
  // Direct Tax links. Two sections must not share a href, or their cards clash
  // in the "All" view.
  links: [
    {
      title: "Disclosure of information under Section 4(1)(b) of the RTI Act, 2005",
      href: "https://www.mca.gov.in/content/mca/global/en/about-us/right-to-information/disclosure.html",
    },
    {
      title: "MCA Monthly Newsletter",
      href: "https://www.mca.gov.in/content/mca/global/en/about-us/newsletter.html",
    },
  ],
};

export default corperateaffair;
